module.exports = __webpack_public_path__ + "img/bg-flag.1b42b792.svg";